import React, {useState, useEffect} from 'react'
import Stack from '@mui/material/Stack'
import ItemLoader, {RendererProps} from '../../components/ItemLoader'
import Page from '../../components/Page'
import EvalRuns from '../../components/EvalRuns'
import AlarmSummary from '../../components/alarms/Summary'
import Subscribe from '../../components/alarms/Subscribe'
import {getAlarm, updateAlarm} from '../../services/alarms'
import {getEvaluations} from '../../services/evaluations'
import {getModels} from '../../services/models'
import type {Alarm as AlarmType, EvaluationsResult, Evaluation, Model} from '../../services/types'

export const fetchAlarm = getAlarm

const ShowAlarm = ({item: alarm, setItem: setAlarm}: RendererProps<AlarmType>) => {
  const [allEvals, setEvaluations] = useState([] as Evaluation[])
  const [allModels, setModels] = useState([] as Model[])

  useEffect(() => {
    const getter = async () => {
      getEvaluations({filters: {fields: ['name']}}).then((r) =>
        setEvaluations(r.items as Evaluation[])
      )
      getModels({filters: {fields: ['name']}}).then((r) => setModels(r.items as Model[]))
    }
    getter()
  }, [])

  const saveAlarm = async (a: AlarmType) => {
    const res = await updateAlarm(a)
    if (res === 'Alarm updated') setAlarm({...alarm, ...a})
  }

  const markThreshold = (runs: EvaluationsResult) => ({
    ...runs,
    thresholds: [{title: 'alarm threshold', mean: alarm.threshold}],
  })

  return (
    <Page title={alarm.name} showTitle>
      <Stack direction="column" spacing={7} sx={{m: 5}}>
        <AlarmSummary
          alarm={alarm}
          updateAlarm={saveAlarm}
          allEvals={allEvals}
          allModels={allModels}
        />

        {alarm?.evaluation?.id && (
          <EvalRuns evals={[alarm?.evaluation]} itemType="model" transformRuns={markThreshold} />
        )}

        <Stack direction="row" justifyContent="center">
          <Subscribe alarm={alarm} sx={{width: 300, p: 1.8, fontSize: '1.5em', borderRadius: 40}} />
        </Stack>
      </Stack>
    </Page>
  )
}

const Alarm: React.FC = () => <ItemLoader itemName="alarm" renderer={ShowAlarm} />
export default Alarm
